/**
 * Created by Santiago on 12/6/17.
 */

export default {
    shareScreen: "Would you like to share your screen?",
    no: "No",
    yes: "Yes",
    youmustpickastar: "You must pick a calification",
    name: "Name",
    email: "E-mail",
    phone: "Phone",
    message: "Message",
    sendMessage: 'Send message',
    newConversation: 'New conversation',
    sendpunctuation: "Send Feedback",
    musttypemail: "You must type your mail",
    validemail: "This is not a valid E-mail",
    screenshare: "Share Screen",
    musttypename: "You must type your name",
    musttypemessage: "You must type a message",
    configuration: "Configuration",
    notifications: "Notifications",
    notificationDetails: "Notify me about new messages that I recive in this chat",
    close: "Close",
    cancel: "Cancel",
    save: "Save",
    willclose: "Closing Chat",
    closeconf: "Are you sure you want to close the chat ?",
    conversationend: "The chat ended, Do you want to close it?",
    newmessage: "New message",
    typehere: "Send a message...",
    whatdoyouthink: "What do you think about the service you have received ?",
    sendbymail: "Send conversation by e-mail",
    holdtimeavg: "Hold time average",
    holdtime: "Your hold time",
    messagesended: "Message Sent!",
    emailerror: "Please enter a valid e-mail to continue",
    fieldserror:"Please check the fields and try again",
    messageserror: "Oops, something went wrong :(",
    message: "Write your Message...",
    transfering: "Transfering...",
    endchat: "End chat",
    videocall: "Videocall",
    call: "Call",
    openinextarnalwindow: "Open in external window",
    calling: "Calling",
    callingduration: "Calling duration",
    mute: "Mute",
    allowmicrophone: "Allow microphone",
    hangup: "Hangup",
    duration: "Duration ",
    write: "Write",
    survey_title: 'We hope you are happy with the service',
    survey_desc: "We'd love to know more about your experience with our support, you think you can take the time to give us some feedback?",
    available: "Available",
    invalidextension: "Attachment format invalid",
    maxfilesize10mb: "Max file size 10 MB",
    accessibility: "Accessibility",
    accessibilityMenu: "Accessibility Menu",
    "Font size": "Font size",
    emojis: {
      search: "Search",
      notfound: "No Emoji Found",
      title: "Pick an Emoji",
      categories: {
        search: "Search Results",
        recent: "Frequently Used",
        people: "Smileys & People",
        nature: "Animals & Nature",
        foods: "Food & Drink",
        activity: "Activity",
        places: "Travel & Places",
        objects: "Objects",
        symbols: "Symbols",
        flags: "Flags",
        custom: "Custom",
      },
    }
};